/**
 * EWG full report display widget.
 * Reads pws_id from URL params or config and renders only the full report.
 * If pws is missing, it renders nothing.
 */
(function () {
  "use strict";

  var CONFIG = window.EWG_REPORT_DISPLAY_CONFIG || {};
  var container = document.getElementById(CONFIG.containerId || "ewg-report-display");
  if (!container) return;
  var base = (CONFIG.apiBaseUrl || "").replace(/\/$/, "");

  function el(tag, attrs, children) {
    var e = document.createElement(tag);
    if (attrs) {
      Object.keys(attrs).forEach(function (k) {
        if (k === "className") e.className = attrs[k];
        else if (k === "html") e.innerHTML = attrs[k];
        else if (k === "onclick") e.onclick = attrs[k];
        else if (attrs[k] != null) e.setAttribute(k, attrs[k]);
      });
    }
    if (children && children.length) children.forEach(function (c) { if (c) e.appendChild(c); });
    return e;
  }

  function text(s) { return document.createTextNode(s); }
  function escapeHtml(s) { return String(s || "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;"); }
  function cleanValueText(s) { return String(s || "").replace(/^This Utility:\s*/i, ""); }
  function setContent(node) { container.innerHTML = ""; if (node) container.appendChild(node); }
  function showLoading(msg) { setContent(el("div", { className: "ewg-loading" }, [text(msg || "Loading...")])); }
  function showError(msg) { setContent(el("div", { className: "ewg-error" }, [text(msg || "Could not load report.")])); }

  function getPwsId() {
    if (CONFIG.pwsId) return CONFIG.pwsId;
    var param = CONFIG.pwsParam || "pws";
    var match = new RegExp("[?&]" + param + "=([A-Za-z0-9]+)").exec(window.location.search || "");
    return match ? match[1] : "";
  }

  function ensureModal() {
    var existing = container.querySelector(".ewg-overlay-modal");
    if (existing) return existing;
    var modal = el("div", { className: "ewg-overlay-modal", hidden: "hidden" }, [
      el("div", { className: "ewg-overlay-backdrop", "data-ewg-modal-close": "1" }),
      el("div", { className: "ewg-overlay-dialog", role: "dialog", "aria-modal": "true" }, [
        el("button", { type: "button", className: "ewg-overlay-close", "data-ewg-modal-close": "1" }, [text("×")]),
        el("div", { className: "ewg-overlay-body" })
      ])
    ]);
    container.appendChild(modal);
    return modal;
  }

  function closeModal() {
    var modal = ensureModal();
    modal.setAttribute("hidden", "hidden");
    modal.querySelector(".ewg-overlay-body").innerHTML = "";
  }

  function openModalHtml(html) {
    var modal = ensureModal();
    modal.querySelector(".ewg-overlay-body").innerHTML = html || "";
    modal.removeAttribute("hidden");
  }

  function loadContaminantDetail(contamcode) {
    if (!contamcode) return;
    openModalHtml('<div class="ewg-loading">Loading contaminant details...</div>');
    fetch(base + "/api/contaminant/" + encodeURIComponent(contamcode))
      .then(function (r) { if (!r.ok) throw new Error("Could not load contaminant details."); return r.json(); })
      .then(function (data) { openModalHtml(data.detail_html || "<p>No contaminant details available.</p>"); })
      .catch(function (err) { openModalHtml('<div class="ewg-error">' + escapeHtml(err.message || "Could not load contaminant details.") + "</div>"); });
  }

  container.addEventListener("click", function (e) {
    var closeEl = e.target.closest("[data-ewg-modal-close]");
    if (closeEl) { e.preventDefault(); closeModal(); return; }
    var link = e.target.closest(".ewg-contaminant-link");
    if (link) { e.preventDefault(); loadContaminantDetail(link.getAttribute("data-contamcode")); }
  });

  function exceedCount(contaminants) {
    return contaminants.filter(function (c) { return !!c.exceed_guideline; }).length;
  }

  function formatTimesAbove(c) {
    var times = c.times_above_guideline;
    if (times == null || times <= 0) return "Detected";
    var rounded = Math.round(times * 10) / 10;
    return String(rounded).replace(/\.0$/, "") + "x above EWG guideline";
  }

  function statGrid(system) {
    return el("div", { className: "ewg-stat-grid" }, [
      el("div", { className: "ewg-stat-card" }, [el("span", { className: "ewg-stat-label" }, [text("Location")]), el("strong", {}, [text(system.location || "")])]),
      el("div", { className: "ewg-stat-card" }, [el("span", { className: "ewg-stat-label" }, [text("Serves")]), el("strong", {}, [text(system.population_served != null ? system.population_served.toLocaleString() : "")])]),
      el("div", { className: "ewg-stat-card" }, [el("span", { className: "ewg-stat-label" }, [text("Source")]), el("strong", {}, [text(system.source || "")])]),
      el("div", { className: "ewg-stat-card" }, [el("span", { className: "ewg-stat-label" }, [text("Data")]), el("strong", {}, [text(system.data_years || "")])])
    ]);
  }

  function healthGuidelineLine(c) {
    if (c.times_above_guideline != null && c.times_above_guideline > 0) {
      return formatTimesAbove(c) + (c.ewg_guideline ? ": " + c.ewg_guideline : "");
    }
    return c.ewg_guideline ? "EWG Health Guideline: " + c.ewg_guideline : "EWG Health Guideline: -";
  }

  function detectedCard(c) {
    var name = c.contaminant_name || c.name || "Contaminant";
    return el("button", {
      type: "button",
      className: "ewg-detected-card" + (c.exceed_guideline ? " ewg-exceeds" : ""),
      onclick: function () { loadContaminantDetail(c.contamcode); }
    }, [
      el("div", { className: "ewg-detected-card-title" }, [text(name)]),
      c.potential_effect && el("div", { className: "ewg-detected-card-effect" }, [text("Potential effect: " + c.potential_effect)]),
      el("div", { className: "ewg-detected-card-metrics" }, [
        el("div", { className: "ewg-detected-card-metric" }, [
          el("span", { className: "ewg-detected-card-label" }, [text("This utility:")]),
          el("strong", {}, [text(cleanValueText(c.value_text) || "-")])
        ]),
        el("div", { className: "ewg-detected-card-metric" }, [
          el("span", { className: "ewg-detected-card-label" }, [text("Legal limit:")]),
          el("strong", {}, [text(c.legal_limit || "None")])
        ])
      ]),
      el("div", { className: "ewg-detected-card-guideline" }, [
        el("span", { className: "ewg-detected-card-guideline-text" }, [text(healthGuidelineLine(c))])
      ]),
      el("div", { className: "ewg-detected-card-footer" }, [text("View chemical details")])
    ].filter(Boolean));
  }

  function sectionNote(html) {
    if (!html) return null;
    return el("div", { className: "ewg-section-note", html: html });
  }

  function reportIntro(system, contaminants, ewgReportUrl) {
    return el("section", { className: "ewg-report-intro-grid" }, [
      el("aside", { className: "ewg-report-sidebar" }, [
        el("div", { className: "ewg-report-sidebar-number" }, [text(String(exceedCount(contaminants)))]),
        el("div", { className: "ewg-report-sidebar-copy" }, [text("Contaminants above EWG health guidelines")]),
        el("div", { className: "ewg-report-sidebar-divider" }),
        el("div", { className: "ewg-report-sidebar-total" }, [text(String(contaminants.length) + " total contaminants detected")])
      ]),
      el("section", { className: "ewg-report-overview-card" }, [
        el("h2", { className: "ewg-overview-title" }, [text("Overview")]),
        el("div", { className: "ewg-report-overview", html: system.overview || "No overview available." })
      ]),
      el("section", { className: "ewg-report-compliance-card" }, [
        el("h2", { className: "ewg-overview-title" }, [text("Legal does not mean safe")]),
        el("p", { className: "ewg-report-compliance-copy" }, [text(system.compliance || "EWG compares detected contaminant levels to health guidelines and legal limits to help show where water quality may still pose health concerns.")]),
        ewgReportUrl && el("a", { href: ewgReportUrl, target: "_blank", rel: "noopener", className: "ewg-report-ewg-link" }, [text("View full report on EWG.org ->")])
      ])
    ]);
  }

  function detectedCardSection(title, contaminants, noteHtml) {
    if (!contaminants.length && !noteHtml) return null;
    return el("section", { className: "ewg-contaminant-section" }, [
      el("h2", { className: "ewg-contaminants-title" }, [text(title)]),
      contaminants.length ? el("div", { className: "ewg-detected-card-grid" }, contaminants.map(detectedCard)) : null,
      sectionNote(noteHtml)
    ]);
  }

  function notDetectedSection(notDetected) {
    if (!notDetected || !notDetected.length) return null;
    var html = notDetected.map(function (item) {
      return '<a href="#" class="ewg-contaminant-link" data-contamcode="' + escapeHtml(item.contamcode) + '">' + escapeHtml(item.chemical_name) + "</a>";
    }).join(", ");
    return el("details", { className: "ewg-not-detected" }, [
      el("summary", { className: "ewg-not-detected-summary" }, [text("Other contaminants tested")]),
      el("div", { className: "ewg-not-detected-body", html: "<p><strong>Chemicals tested for but not detected:</strong></p><p>" + html + "</p>" })
    ]);
  }

  function reportView(system, contaminants, ewgReportUrl, notDetected) {
    var frag = document.createDocumentFragment();
    frag.appendChild(el("section", { className: "ewg-report-hero" }, [
      el("div", { className: "ewg-report-label" }, [text("UTILITY")]),
      el("h1", { className: "ewg-report-title" }, [text(system.name || "Water Quality Report")]),
      statGrid(system),
      el("div", { className: "ewg-report-summary-grid" }, [
        el("div", { className: "ewg-summary-card ewg-summary-card-warning" }, [el("strong", {}, [text(String(exceedCount(contaminants)))]), el("span", {}, [text("Contaminants exceed EWG's health guidelines")])]),
        el("div", { className: "ewg-summary-card" }, [el("strong", {}, [text(String(contaminants.length))]), el("span", {}, [text("Total contaminants detected")])])
      ])
    ]));
    var exceeds = contaminants.filter(function (c) { return !!c.exceed_guideline; });
    var others = contaminants.filter(function (c) { return !c.exceed_guideline; });
    frag.appendChild(el("div", { className: "ewg-contaminants" }, [reportIntro(system, contaminants, ewgReportUrl), detectedCardSection("Exceeded Guidelines", exceeds, system.above_guideline_note), detectedCardSection("Other Detected", others, system.other_detected_note), notDetectedSection(notDetected)].filter(Boolean)));
    return frag;
  }

  var pwsId = getPwsId();
  if (!pwsId) { container.innerHTML = ""; return; }
  showLoading("Loading report...");
  fetch(base + "/api/report/" + encodeURIComponent(pwsId))
    .then(function (r) { if (!r.ok) throw new Error(r.status === 404 ? "Report not found" : "Could not load report."); return r.json(); })
    .then(function (report) {
      setContent(el("div", { className: "ewg-report-display-widget" }, [reportView(report.system, report.contaminants || [], report.ewg_report_url, report.not_detected_chemicals || [])]));
    })
    .catch(function (err) { showError(err.message || "Could not load report."); });
})();
